/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../../components/Translate/I18n';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export type CallBlockElementType = {
    name: string | number | null;
    params: Array<any> | null;
};

export const CallBlockElement: FunctionComponent<CallBlockElementType> = ({ name, params }) => {
    if (typeof name === 'number') {
        return (
            <React.Fragment>
                <TableRow>
                    <TableCell padding="none" align="left">
                        <I18n trans="prov:f.get_ok" />
                    </TableCell>
                    <TableCell padding="none" align="right">
                        <I18n trans="prov:f.call_block" />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell colSpan={2} padding="none" align="right">
                        {name}
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }
    if (typeof name === 'string') {
        return (
            <React.Fragment>
                <TableRow>
                    <TableCell padding="none" align="left">
                        <I18n trans="prov:f.get_ok" />
                    </TableCell>
                    <TableCell padding="none" align="right">
                        <I18n trans="prov:f.call_block" />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell colSpan={2} padding="none" align="right">
                        {name}
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }
    return null;
};
